import {environment} from '../../../../../environments/environment';
import {Injectable} from '@angular/core';
import {SupportRequest} from '../../interfaces/SupportRequest';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';


@Injectable()
export class RequestSupportService {
  private route = 'supportrequest';

  constructor(private http: AuthHttp) { }

  public SendSupportRequestEmail(request: SupportRequest): Promise<void> {
    return this.http.post(`${environment.baseUrl}${this.route}`, request)
      .map(res => res.json().message).toPromise();
  }
}





// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/request-support/request-support.service.ts